import * as Colors from 'shared/styles/colors';

/* Default avatar piece color sets */

export const SkinColors = [
  Colors.red,
  Colors.orange,
  Colors.lightBlue,
  Colors.cornflower,
  Colors.green,
  Colors.lightCrimson,
  Colors.bisque,
  Colors.goldCrayola,
  Colors.lightTaupe,
  Colors.metallicBronze,
  Colors.rawUmber,
];

export const HairBaseColors = [
  Colors.red,
  Colors.purple,
  Colors.yellow,
  Colors.cream,
  Colors.lightBlue,
  Colors.crimson,
];

// Highlight colors are matched with base colors by index
export const HairHighlightColors = [
  Colors.yellow,
  Colors.cornflower,
  Colors.cream,
  Colors.white,
  Colors.cream,
  Colors.red,
];

export const AccessoryBaseColors = [
  Colors.red,
  Colors.yellow,
  Colors.purple,
  Colors.cream,
  Colors.lightBlue,
  Colors.crimson,
  Colors.cornflower,
  Colors.lightGray,
  Colors.brown,
];

export const BackgroundBaseColors = [
  Colors.red,
  Colors.purple,
  Colors.yellow,
  Colors.cream,
  Colors.lightBlue,
  Colors.crimson,
  Colors.cornflower,
  Colors.brown,
  Colors.lightGray,
];

// Only Mouth03 uses colors
export const MouthColors = [
  Colors.red,
  Colors.yellow,
  Colors.purple,
  Colors.cream,
  Colors.lightBlue,
  Colors.crimson,
  Colors.cornflower,
  Colors.brown,
  Colors.lightGray,
];

/* Special avatar piece color sets */

export const AccessoryAlt1BaseColors = [
  Colors.red,
  Colors.yellow,
  Colors.purple,
  Colors.lightBlue,
  Colors.crimson,
  Colors.cornflower,
];

export const AccessoryHighlightColorsAlt1 = [
  Colors.yellow,
  Colors.crimson,
  Colors.red,
  Colors.cornflower,
  Colors.yellow,
  Colors.lightBlue,
];

export const Accessory05HighlightColors = [
  Colors.cream,
  Colors.cream,
  Colors.cream,
  Colors.yellow,
  Colors.cream,
  Colors.cream,
  Colors.cream,
  Colors.cream,
  Colors.cream,
];

export const AccessoryAlt3BaseColors = [Colors.yellow, Colors.crimson];

export const AccessoryAlt4BaseColors = [
  Colors.yellow,
  Colors.purple,
  Colors.brown,
];

export const AccessoryAlt7BaseColors = [
  Colors.yellow,
  Colors.red,
  Colors.lightBlue,
  Colors.cream,
  Colors.brown,
];
